var _defs, _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_13",
    x1: 540,
    y1: 1038.03,
    x2: 540,
    y2: 41.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083c8"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.97,
    y: 41.97,
    width: 996.05,
    height: 996.05,
    rx: 273.3,
    fill: "url(#Degradado_sin_nombre_13)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M604.73,654.66c0,4.24,0,8.09,0,11.93,0,7.2-1.3,8.48-8.35,8.49H571.86v5.55q0,42.14,0,84.27c0,7.05-1.13,8.22-8,8.23q-23.75,0-47.49,0c-7,0-8.16-1.16-8.17-8.06q0-41.91,0-83.81v-6.18h-19.7c-13.19,0-13.19,0-13.19-13.43,0-2.14,0-4.29,0-7H445.19c-11.62,0-11.63,0-11.63-11.62,0-27.16.08-54.32-.12-81.48a12.7,12.7,0,0,0-2.91-7.75c-74.29-82.8-34.75-214.07,73.06-242.27,82.51-21.58,168,33.63,181.76,117.8,7.69,46.93-4.4,88.48-35.87,124.22a11.46,11.46,0,0,0-3.05,8.32c.1,28.09.07,56.18.06,84.27,0,7.47-1.08,8.51-8.7,8.51ZM636,644v-5.43c0-26.84,0-53.69-.06-80.53a12.31,12.31,0,0,1,3.48-9.14c30.49-33.15,42.59-72.12,35.73-116.63-12.62-82-98.92-134.39-177.42-108C401.63,356.53,371.58,475,440.55,549.06a13.8,13.8,0,0,1,3.4,8.54c.26,27,.16,54,.16,81v5.26h30.78V521.51c-3.8,0-7.19.06-10.58,0s-5.33-1.76-5.38-5.12,1.91-5.09,5.23-5.25c1.24-.06,2.48,0,3.72,0h114c10.7,0,21.41,0,32.11,0,4.87,0,7.32,1.78,7.08,5.29-.3,4.58-3.52,5.26-7.29,5.15-2.88-.09-5.77,0-8.72,0V644ZM593.87,521.85H486.17V664.2h107.7Zm-75.1,240.39h42.35V675.47H518.77Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M539.78,460h-91.2c-7.36,0-8.81-1.32-8.35-8.77,2.53-41.4,22.49-71.71,60.39-88.11s73.64-10.19,105.07,16.42c22,18.66,33.15,43.21,34.16,72.17.24,6.82-1.21,8.28-8,8.28Q585.84,460,539.78,460Zm60.33-71.5c-16.4-14.15-34-21.68-54.73-23,0,3.21.09,5.83,0,8.44-.14,3.31-1.55,5.85-5.21,5.9-3.91.06-5.36-2.57-5.47-6.1-.09-2.59,0-5.19,0-8.27-20.82,1.38-38.39,8.85-54.34,22.67,2.52,2.27,4.67,4.05,6.63,6,2.3,2.31,2.66,5,.33,7.44-2.49,2.58-5.35,2.3-7.81-.1-2-1.94-3.65-4.2-5.8-6.72-14,16.1-21.41,33.74-22.82,54.32h41.36c4.46-23.81,18.7-37.82,42.47-42.36,0-2.63-.13-5,0-7.25.22-3.15,1.8-5.43,5.15-5.5,3.6-.08,5.26,2.28,5.48,5.64.16,2.3,0,4.61,0,7.12,23.94,4.54,38,18.73,42.47,42.3H629.2c-1.5-20.58-8.85-38.23-22.68-54.08-2,2.23-3.46,4-5,5.71-2.51,2.69-5.47,4-8.49,1.12s-1.94-5.93.87-8.42C595.7,391.73,597.74,390.29,600.11,388.45Zm-65.65,29.76c-15.34,1-31.38,17.31-30.5,30.77h30.5Zm41.84,30.9c0-13.1-15.21-30.86-30.57-30.57v30.57Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M540.51,587.65c10.07,0,20.14,0,30.21,0,3.76,0,7,.76,7.41,5.18.37,3.51-2.39,5.51-7.46,5.52-20.45,0-40.9,0-61.35,0-3.71,0-7-.63-7.4-5.14-.32-3.54,2.43-5.54,7.45-5.55C519.75,587.62,530.13,587.65,540.51,587.65Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M539.54,633H509.33c-3.71,0-7-.72-7.41-5.19-.33-3.55,2.41-5.57,7.44-5.57,20.45,0,40.9,0,61.36,0,3.74,0,7,.74,7.41,5.17.36,3.51-2.44,5.58-7.45,5.6C560.3,633,549.92,633,539.54,633Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M540.07,563.77H510.8c-1.24,0-2.49,0-3.72-.1-3.25-.31-5.27-2.08-5.14-5.39s2.29-5.07,5.51-5.08q32.52-.08,65.05,0c3.43,0,5.69,1.9,5.6,5.44s-2.61,5.08-6,5.09c-10.69,0-21.37,0-32.06,0Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPar);
export default __webpack_public_path__ + "static/media/icon-par.0cb264a614edb61b43f6e25deb47b3ee.svg";
export { ForwardRef as ReactComponent };